import { useRoute, useRuntimeConfig, createError } from '#imports'

export function useIframeAuth() {
  const route = useRoute()
  const config = useRuntimeConfig()

  const isIframe = computed(() => route.query.isIframe == 'true')
  const isTokenValid = computed(() => route.query.token == config.public.iframeToken)

  if (isIframe.value && !isTokenValid.value) {
    throw createError({
      statusCode: 404,
      statusMessage: 'Pagina not found',
    })
  }

  return { isIframe, isTokenValid }
}
